import FixturesSearchBar from './fixturesSearchBar.component';

export * from './fixturesSearchBar.types';
export default FixturesSearchBar;
